import React from 'react';
import { Navbar, Nav, Container } from 'react-bootstrap';
import { Link, NavLink } from 'react-router-dom';
import './Header.css';
import logo from '../images/logo.png';

const Header = () => {
  return (

    

    <Navbar bg="dark" expand="lg" sticky="top" className='navbar navbar-expand-lg bg-body-tertiary'>
      <Container>
        <Navbar.Brand as={Link} to="/" className="fw-bold">
    
         <img src={logo} alt="Logo"/>
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <ul className="navbar-nav ms-auto">
            <li><Nav.Link as={NavLink} to="/">Home</Nav.Link></li>
            <li><Nav.Link as={NavLink} to="/about">About us</Nav.Link></li>
            <li><Nav.Link as={NavLink} to="/timetables">Time Tables</Nav.Link></li>
            <li><Nav.Link as={NavLink} to="/results">Results</Nav.Link></li>
            <li><Nav.Link as={NavLink} to="/circulars">Circulars</Nav.Link></li>
            <li><Nav.Link as={NavLink} to="/grievanances">Grievances Redressal</Nav.Link></li>
            <li><Nav.Link as={NavLink} to="/contact">Contact</Nav.Link></li>
            <li><Nav.Link as={NavLink} to="/ourstaff" className='our-staff'>Our Staff</Nav.Link></li> 
            {/* <Nav.Link as={NavLink} to="/admin">Admin</Nav.Link> */}
         
          

          </ul>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default Header;
